import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface VapiAccount {
  keyName: string;
  friendlyName: string;
  isPrimary: boolean;
}

export function useVapiKeys() {
  const [accounts, setAccounts] = useState<VapiAccount[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAccounts();
  }, []);

  const loadAccounts = async () => {
    try {
      setLoading(true);
      
      const { data, error } = await supabase.functions.invoke('manage-api-keys', {
        body: { 
          action: 'get', 
          filter_provider: 'vapi' 
        }
      });

      if (error) throw error;

      const vapiAccounts: VapiAccount[] = (data?.keys || []).map((k: any) => ({
        keyName: k.key_name,
        friendlyName: k.friendlyName || 'VAPI Account',
        isPrimary: k.key_name === 'api_key'
      }));

      setAccounts(vapiAccounts);
    } catch (error) {
      console.error('Error loading VAPI accounts:', error);
      setAccounts([]);
    } finally {
      setLoading(false);
    }
  };

  const getVapiFriendlyName = (keyName: string): string => {
    const account = accounts.find(acc => acc.keyName === keyName);
    return account?.friendlyName || 'VAPI Account';
  };

  const hasMultipleKeys = accounts.length > 1;

  return {
    accounts,
    loading,
    getVapiFriendlyName,
    hasMultipleKeys
  };
}